class ZZRadioTabsItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 创建radio input
    const groupName =
      this.closest('zz-radio-tabs')?.getAttribute('name') || 'option';
    // 获取checked属性 - 支持checked和checked="true"两种方式
    const checked = this.hasAttribute('checked');
    const value = this.getAttribute('value') || '';
    const slot = this.innerHTML;
    this.innerHTML = `
      <label class="zz-radio-tabs-wrapper">
        <input type="radio" name=${groupName} value=${value} ${checked ? 'checked' : ''}>
        <div class="zz-radio-tabs-label">
            ${slot}
        </div>
      </label>
    `;
  }
}

/**
 * type: default, black 两种风格模式
 */
class ZZRadioTabs extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    // 获取组件的type属性
    const type = this.getAttribute('type') || 'default';
    // 给自己加class
    this.classList.add('zz-radio-tabs');
    this.classList.add(`zz-radio-tabs-${type}`);
  }

  get value() {
    const selectedRadio = this.querySelector('input[type="radio"]:checked');
    return selectedRadio?.value;
  }

  set value(val) {
    const radio = this.querySelector(`input[type="radio"][value="${val}"]`);
    if (radio) {
      radio.checked = true;
    }
  }
}

// 注册自定义元素
customElements.define('zz-radio-tabs-item', ZZRadioTabsItem);
customElements.define('zz-radio-tabs', ZZRadioTabs);

// 页面加载完成后执行
document.addEventListener('DOMContentLoaded', function () {
  // 点击视频播放/暂停
  // 在 video 标签上添加 class='click-video-play-pause' 即可
  (function () {
    const videoPlayAndPause = document.querySelectorAll(
      '.click-video-play-pause'
    );
    videoPlayAndPause.forEach((video) => {
      video.classList.remove('video-play-pause');
      video.addEventListener('click', function () {
        if (this.paused) {
          this.play();
        } else {
          this.pause();
        }
      });
    });
  })();
});
/**
 * 视频按钮+弹窗
 */
class ZZVideoBtn extends HTMLElement {
  constructor() {
    super();
    this.togglePopup = this.togglePopup.bind(this);
    this.popup = null;
  }

  connectedCallback() {
    this.querySelectorAll('.togglePopup').forEach((el) => {
      el.addEventListener('click', (event) => {
        console.log('click');
        if (event.target.tagName !== 'VIDEO') {
          this.togglePopup();
        }
      });
    });
    this.popup = this.querySelector('.popup');

    if (this.popup) {
      // 将 popup 移动到 body
      document.body.appendChild(this.popup);
    } else {
      console.error('Popup element not found.');
    }
  }

  disconnectedCallback() {
    if (this.popup && document.body.contains(this.popup)) {
      document.body.removeChild(this.popup); // 清理 popup 元素
    }
  }

  togglePopup() {
    if (!this.popup) return;

    const isHidden = this.popup.classList.contains('!tw-hidden');

    if (isHidden) {
      this.showPopup();
    } else {
      this.hidePopup();
    }
  }

  showPopup() {
    if (!this.popup) return;

    this.popup.classList.remove('!tw-hidden');
    gsap.fromTo(
      this.popup,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.3,
        ease: 'linear',
        backdropFilter: 'blur(30px)',
        onComplete: () => {
          const video = this.popup.querySelector('video');
          if (video) {
            video.play();
          }
        },
      }
    );
  }

  hidePopup() {
    if (!this.popup) return;

    gsap.to(this.popup, {
      opacity: 0,
      duration: 0.3,
      ease: 'linear',
      onComplete: () => {
        this.popup.classList.add('!tw-hidden');
        const video = this.popup.querySelector('video');
        if (video) {
          video.pause();
        }
      },
    });
  }
}

if (!customElements.get('zz-video-button')) {
  customElements.define('zz-video-button', ZZVideoBtn);
}

if (!customElements.get('zz-video-popup')) {
  class ZZVideoPopup extends HTMLElement {
    constructor() {
      super();
      this.togglePopup = this.togglePopup.bind(this);
      this.popup = null;
    }

    connectedCallback() {
      this.querySelectorAll('.togglePopup').forEach((el) => {
        el.addEventListener('click', (event) => {
          console.log('click');
          if (event.target.tagName !== 'VIDEO') {
            this.togglePopup();
          }
        });
      });
      this.popup = this.querySelector('.popup');
    }

    disconnectedCallback() {
      if (this.popup && document.body.contains(this.popup)) {
        document.body.removeChild(this.popup); // 清理 popup 元素
      }
    }

    togglePopup() {
      if (!this.popup) return;
      if (this.popup) {
        // 将 popup 移动到 body
        document.body.appendChild(this.popup);
      } else {
        console.error('Popup element not found.');
      }

      const isHidden = this.popup.classList.contains('!tw-hidden');

      if (isHidden) {
        this.showPopup();
      } else {
        this.hidePopup();
      }
    }

    showPopup() {
      if (!this.popup) return;

      this.popup.classList.remove('!tw-hidden');
      gsap.fromTo(
        this.popup,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.3,
          ease: 'linear',
          backdropFilter: 'blur(30px)',
          onComplete: () => {
            const videos = this.popup.querySelectorAll('video');
            videos.forEach((video) => {
              if (window.getComputedStyle(video).display !== 'none') {
                video.play();
              }
            });
          },
        }
      );
    }

    hidePopup() {
      if (!this.popup) return;

      gsap.to(this.popup, {
        opacity: 0,
        duration: 0.3,
        ease: 'linear',
        onComplete: () => {
          this.popup.classList.add('!tw-hidden');
          const videos = this.popup.querySelectorAll('video');
          videos.forEach((video) => {
            if (video) {
              video.pause();
            }
          });
        },
      });
      if (this.popup && document.body.contains(this.popup)) {
        document.body.removeChild(this.popup); // 清理 popup 元素
      }
    }
  }
  customElements.define('zz-video-popup', ZZVideoPopup);
}

if (!customElements.get('zz-video-handler')) {
  class ZZVideoHandler extends HTMLElement {
    constructor() {
      super();
      this.videoPlayBtn = this.querySelector('.video-play-btn');
      this.videos = this.querySelectorAll('.zz-video');

      if (this.videoPlayBtn && this.videos.length > 0) {
        this.videoPlayBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.togglePlay();
        });

        this.videos.forEach((video) => {
          video.addEventListener('click', () => {
            this.togglePlay();
          });
        });
      }
    }

    togglePlay() {
      this.videos.forEach((video) => {
        if (video.classList.contains('tw-hidden')) {
          return;
        }
        if (video.paused) {
          video.play();
          this.videoPlayBtn.classList.add('tw-hidden');
        } else {
          video.pause();
          this.videoPlayBtn.classList.remove('tw-hidden');
        }
      });
    }

    pauseVideo() {
      this.videos.forEach((video) => {
        if (!video.paused) {
          video.pause();
          this.videoPlayBtn.classList.remove('tw-hidden');
        }
      });
    }
  }
  customElements.define('zz-video-handler', ZZVideoHandler);
}

/**
 * Toast 组件
 */
(function () {
  let toastEl = null;
  let hideTimer = null;

  const toastIcon = {
    error: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_19382_20972)">
              <circle cx="9" cy="9" r="9" fill="#FF4D4F"/>
              <path d="M6.24231 6.17188L11.8992 11.8287" stroke="white" stroke-linecap="round"/>
              <path d="M6.24231 11.8281L11.8992 6.17127" stroke="white" stroke-linecap="round"/>
              </g>
              <defs>
              <clipPath id="clip0_19382_20972">
              <rect width="18" height="18" fill="white"/>
              </clipPath>
              </defs>
          </svg>
          `,
    success: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_19382_20921)">
                <circle cx="9" cy="9" r="9" fill="#5BC726"/>
                <path d="M5 9L7.82843 11.8284L12.7782 6.87868" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                <clipPath id="clip0_19382_20921">
                <rect width="18" height="18" fill="white"/>
                </clipPath>
                </defs>
            </svg>
            `,
    warning: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_19382_20989)">
              <circle cx="9" cy="9" r="9" fill="#FAAD14"/>
              <path d="M8.99994 5L8.99994 10" stroke="white" stroke-linecap="round"/>
              <circle cx="9.00001" cy="12.8" r="0.8" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_19382_20989">
              <rect width="18" height="18" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            `,
  };

  function createToast() {
    const layer = document.createElement('div');
    layer.className = 'zz-toast-layer';
    layer.setAttribute('aria-live', 'assertive');
    layer.setAttribute('aria-atomic', 'true');

    const box = document.createElement('div');
    box.className = 'zz-toast-box';
    box.setAttribute('role', 'alert');

    const msg = document.createElement('span');
    msg.className = 'zz-toast-msg';

    const icon = document.createElement('span');
    icon.className = 'zz-toast-icon';

    box.appendChild(icon);
    box.appendChild(msg);
    layer.appendChild(box);
    document.body.appendChild(layer);

    return { layer, box, msg, icon };
  }

  /**
   * 显示错误 Toast
   * @param {string} message - 要显示的错误文字
   * @param {{duration?:number,type?:string}} [opts]
   */
  function zzShowToast(message, opts = {}) {
    if (!toastEl) {
      toastEl = createToast();
    }

    // 更新文本
    toastEl.msg.textContent = message ?? '';
    if (opts.type) {
      toastEl.icon.innerHTML = toastIcon[opts.type];
    } else {
      toastEl.icon.innerHTML = '';
    }

    // 重新插入到 body 末尾，保证在最上层
    document.body.appendChild(toastEl.layer);
    // 显示动画
    requestAnimationFrame(() => {
      toastEl.box.classList.add('show');
    });
    // 清理上一次的计时器
    clearTimeout(hideTimer);
    const duration = Math.max(500, Number(opts.duration || 2000));
    hideTimer = setTimeout(() => {
      toastEl.box.classList.remove('show');
      // 动画结束后移除节点（留层以复用 DOM 也行，这里直接移除）
      setTimeout(() => {
        toastEl.layer.remove();
        toastEl = null;
      }, 200);
    }, duration);
  }

  // 暴露到全局
  window.zzShowToast = zzShowToast;
})();

(function () {
  let scrollTop = 0;

  function isSafari() {
    const ua = navigator.userAgent;
    // 包含 Safari / WebKit，且不包含 Chrome / CriOS / FxiOS / Android
    return (
      /Safari/.test(ua) &&
      /AppleWebKit/.test(ua) &&
      !/CriOS|FxiOS|Chrome|Edg|OPR/.test(ua)
    );
  }

  function isSafari26() {
    const ua = navigator.userAgent;
    if (!isSafari()) return false;
    // 检查 “Version/26.0” 或类似标识
    return /Version\/26\./.test(ua);
  }

  function lockBodyScroll() {
    if (isSafari26()) {
      scrollTop = window.scrollY;
      document.documentElement.classList.add('zz-global-noscroll');
    } else {
      document.body.style.overflow = 'hidden';
    }
  }

  function unlockBodyScroll() {
    if (isSafari26()) {
      document.documentElement.classList.remove('zz-global-noscroll');
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo(0, scrollTop);
      requestAnimationFrame(() => {
        document.documentElement.style.scrollBehavior = '';
      });
    } else {
      document.body.style.overflow = '';
    }
  }
  window.zzLockBodyScroll = lockBodyScroll;
  window.zzUnlockBodyScroll = unlockBodyScroll;
})();

/**获取当前显示的媒体元素 */
function getVisibleDisplayMedias(container) {
  const videos = container.querySelectorAll('video');
  const video = Array.from(videos).find((video) => {
    const style = window.getComputedStyle(video);
    return style.display !== 'none';
  });
  if (video) {
    return {
      video,
      type: 'video',
    };
  } else {
    const images = container.querySelectorAll('img');
    const image = Array.from(images).find((image) => {
      const style = window.getComputedStyle(image);
      return style.display !== 'none';
    });
    if (image) {
      return {
        image,
        type: 'image',
      };
    }
  }
  return null;
}

// component 统一的初始化入口
document.addEventListener('DOMContentLoaded', (event) => {
  const isDesktop = window.innerWidth > 1023;

  // 处理所有组件可见逻辑处理
  const compIntersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      if (entry.isIntersecting) {
      } else {
        if (el.classList.contains('zz-card-animate-list')) {
          // 重置所有
          el.querySelectorAll('.zz-card-inner').forEach((card) => {
            card.classList.remove('is-active');
          });
        }
      }
    });
  });

  if (!isDesktop) {
    const switchCard = document.querySelectorAll('.product-switch-card');
    // 监听所有的switchCard 当它完全出现屏幕中时候，定时2秒切换成背景图。移出屏幕时候恢复

    if (switchCard.length > 0) {
      const switchTimers = new Map(); // 存储每个卡片的定时器

      const switchCardObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const card = entry.target;
            console.log('switchCardObserver');
            if (entry.isIntersecting && entry.intersectionRatio >= 0.8) {
              // 完全出现在屏幕中，2秒后切换成背景图
              const timer = setInterval(() => {
                if (card.classList.contains('switchCard')) {
                  card.classList.remove('switchCard');
                } else {
                  card.classList.add('switchCard');
                }
              }, 2000);
              switchTimers.set(card, timer);
            } else {
              // 移出屏幕，恢复原状
              const timer = switchTimers.get(card);
              if (timer) {
                clearInterval(timer);
                switchTimers.delete(card);
              }
              card.classList.remove('switchCard');
            }
          });
        },
        {
          threshold: [0.2, 0.8], // 监听0%、99%和100%的可见度
        }
      );

      switchCard.forEach((card) => {
        switchCardObserver.observe(card);
      });
    }
  }

  // 处理统一的定位脚本
  document.addEventListener('click', (e) => {
    // data-zz-module-name
    const positionTrigger = e.target.closest('[data-zz-module-target]');
    if (positionTrigger) {
      const selector = positionTrigger.getAttribute('data-zz-module-target');
      if (selector) {
        const target = document.querySelector(
          `[data-zz-module-name="${selector}"]`
        );
        const headerHeight = 50;
        const offsetTop = target.offsetTop - headerHeight;
        window.scrollTo(0, offsetTop);
      }
      return;
    }
  });

  // zz-card-animate-text.liquid
  const cardListGroup = document.querySelectorAll('.zz-card-animate-list');
  cardListGroup.forEach((list) => {
    if (!list) return;
    if (isDesktop) return;
    list.addEventListener('click', (e) => {
      const item = e.target.closest('.zz-card-inner');
      if (!item || !list.contains(item)) return;

      console.log('click card item');

      // 重置所有
      list.querySelectorAll('.zz-card-inner').forEach((el) => {
        el.classList.remove('is-active');
      });

      // 当前设为 B 状态
      item.classList.add('is-active');
    });
    compIntersectionObserver.observe(list);
  });
});

if (!customElements.get('zz-normal-modal')) {
  class ZZNormalModal extends HTMLElement {
    constructor() {
      super();
      this.handleOverlayClick = this.handleOverlayClick.bind(this);
      this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    connectedCallback() {
      this.dialogContent = this.querySelector('[data-modal-content]');
      this.overlay = this.querySelector('[data-modal-overlay]');
      this.closeButton = this.querySelector('[data-modal-close]');

      if (this.overlay) {
        this.overlay.addEventListener('click', this.handleOverlayClick);
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.handleCloseClick);
      }
    }

    disconnectedCallback() {
      if (this.overlay) {
        this.overlay.removeEventListener('click', this.handleOverlayClick);
      }

      if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.handleCloseClick);
      }

      document.removeEventListener('keydown', this.handleDocumentKeydown);
    }

    show() {
      this.previousActiveElement = document.activeElement;
      this.dialogContent.classList.add('is-open');
      this.overlay.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      window.zzLockBodyScroll && window.zzLockBodyScroll();
      document.addEventListener('keydown', this.handleDocumentKeydown);

      requestAnimationFrame(() => {
        if (this.dialogContent) {
          this.dialogContent.focus();
        }
      });
    }

    hide() {
      this.dialogContent.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      window.zzUnlockBodyScroll && window.zzUnlockBodyScroll();
      document.removeEventListener('keydown', this.handleDocumentKeydown);

      if (
        this.previousActiveElement &&
        typeof this.previousActiveElement.focus === 'function'
      ) {
        this.previousActiveElement.focus();
      }
    }

    handleOverlayClick() {
      this.hide();
    }

    handleCloseClick() {
      console.log('click-close');
      this.hide();
    }

    handleDocumentKeydown(event) {
      if (event.key === 'Escape') {
        this.hide();
      }
    }
  }

  customElements.define('zz-normal-modal', ZZNormalModal);
}

function updateCountryVisibility(currentCountry, marketWordList) {
  console.log('updateCountryVisibility', currentCountry);
  if (!currentCountry) return;

  // currentCountry 当前国家记录的是PHcountry
  // 查找currentCountry对应的showCountry
  const selectCountry = marketWordList.find(
    (item) => item.PHcountry === currentCountry
  );
  if (!selectCountry) return;
  currentCountry = selectCountry.showCountry;
  const isEuropeCountry = selectCountry.formState === 'Europe';

  // visibleCountries 使用的是marketWordList中country字段
  currentCountry = currentCountry.toUpperCase();

  document.querySelectorAll('[data-visibility-rule]').forEach((element) => {
    if (!element.dataset.visibilityCountries) return;

    const rule = element.dataset.visibilityRule;
    const countries = (element.dataset.visibilityCountries || '')
      .split(',')
      .map((item) => item.trim().toUpperCase())
      .filter(Boolean);
    const isMatchedCountry =
      countries.includes(currentCountry) ||
      (countries.includes('EU') && isEuropeCountry);

    let visible = true;

    switch (rule) {
      case 'country_only':
        visible = isMatchedCountry;
        break;

      case 'country_exclude':
        visible = !isMatchedCountry;
        break;

      default:
        visible = true;
    }

    if (visible) {
      element.classList.remove('zz-hidden');
    } else {
      element.classList.add('zz-hidden');
    }
  });
}
